// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1NXDj","name":"Header_name__2YuIL","birthday":"Header_birthday__2jy74","skeleton":"Header_skeleton__3Udq6"};